import { use } from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { DEFAULT_LANGUAGE } from './helpers';
export var defaultNS = 'translation';
var i18n = use(initReactI18next)
    .use(LanguageDetector)
    .use(Backend)
    .init({
    lng: DEFAULT_LANGUAGE,
    defaultNS: defaultNS,
    fallbackLng: DEFAULT_LANGUAGE,
    initImmediate: false,
    backend: {
        loadPath: '/public/locales/{{lng}}/{{ns}}.json',
    },
});
export default i18n;
